const factors = [
  {
    name: 'Еда, рацион питания, принципы здорового питания',
    weight: 10,
  },
  {
    name: 'Режим сна и бодрствования (качество сна)',
    weight: 11,
  },
  {
    name: 'Физическая нагрузка (физкультура), активный отдых, чтобы быть здоровыми',
    weight: 8,
  },
  {
    name: 'Распорядок дня и порядок вещей в доме',
    weight: 7,
  },
  {
    name: 'Труд. Возможность трудиться для блага родных.',
    weight: 6,
  },
  {
    name: 'Возможность пользоваться культурными достижениями (помощь в исцелении, помощь в обучении)',
    weight: 5,
  },
  {
    name: 'Семейное единство. Семейные традиции и родственная общность',
    weight: 4,
  },
  {
    name: 'Окружающая среда (чистая вода, чистый воздух, близость к природе)',
    weight: 3,
  },
  {
    name: 'Окружение друзьями и людьми с которыми хочется быть',
    weight: 2,
  },
  {
    name: 'Комфортное жильё с личным пространством',
    weight: 1,
  },
]

export const getFactors = () => factors
